import React, { useEffect, useState } from 'react';
import { notification, Modal, Form, Select, Row } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useHttp } from '../../Hooks/Http.hook';
import { changeCity, changePhone } from '../../Redux/actions';

const ChangeCity = ({ className }) => {
    const { request } = useHttp(false);
    const [cityOption, setCityOption] = useState([]);
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const city = useSelector((state) => state.city).items ?? {};
    const [defaultCity, setDefaultCity] = useState('Выберите город');
    const dispatch = useDispatch();

    useEffect(() => {
        const getData = () => {
            request('/api/dict/city', 'GET')
                .then((res) => {
                    if (!res?.error) {
                        const rezult = [];
                        res?.data.forEach((item) => {
                            rezult.push({ label: item.name, value: item.id });
                        });
                        if (!city.city) {
                            const cityInfo = {
                                city: rezult[0]?.value,
                                cityName: rezult[0]?.label,
                            };
                            setDefaultCity(rezult[0]?.label);
                            dispatch(changeCity(cityInfo));
                            dispatch(changePhone('+7(981)821-83-40'));
                            form.setFieldValue('city', rezult[0]?.value);
                        }
                        setCityOption(rezult);
                    } else {
                        notification.warning({
                            message: 'Не удалось загрузить список городов',
                        });
                    }
                })
                .catch(() =>
                    notification.warning({
                        message: 'Не удалось загрузить список городов',
                    })
                );
        };
        getData();
    }, []);
    const okHandler = () => {
        form.submit();
    };
    const onFinishHandler = (fields) => {
        const cityInfo = {
            city: fields.city,
            cityName: cityOption.find((item) => item.value === fields.city)
                ?.label,
        };
        dispatch(changeCity(cityInfo));
        dispatch(changePhone('+7(981)821-83-41'));
        setOpen(false);
    };
    return (
        <div>
            <Row
                className={className}
                onClick={() => {
                    setOpen(true);
                    if (city) {
                        form.setFieldValue('city', city.city);
                    }
                }}
            >
                {city?.cityName ?? defaultCity}
            </Row>
            <Modal
                open={open}
                okText="Сохранить"
                onCancel={() => {
                    setOpen(false);
                    form.resetFields();
                }}
                title="Выберите город"
                onOk={okHandler}
            >
                <Form form={form} onFinish={onFinishHandler}>
                    <Form.Item
                        label="Город"
                        name="city"
                        rules={[{ required: true, message: 'Выберите город' }]}
                    >
                        <Select
                            options={cityOption}
                            placeholder="Выберите город"
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default ChangeCity;
